import { render, staticRenderFns } from "./FinalScore.vue?vue&type=template&id=9f637ff4&scoped=true&"
import script from "./FinalScore.vue?vue&type=script&lang=js&"
export * from "./FinalScore.vue?vue&type=script&lang=js&"
import style0 from "./FinalScore.vue?vue&type=style&index=0&id=9f637ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f637ff4",
  null
  
)

export default component.exports